import moment from "moment";

export function getFechasVigencia(oPoliza) {
	let fInicio = oPoliza.generales.fchVigenciaInicial;
	let fFin = oPoliza.generales.fchVigenciaFinal;
	let fInicioLargo = "";
	let fFinLargo = "";

	if (oPoliza.generales.cveRamo == "V" && oPoliza.generales.cveSistema != "PLNK") {
		if (oPoliza.generales.cveClasificacionSeguro != "06" && oPoliza.generales.cveClasificacionSeguro != "05" || oPoliza.generales.cveProdTecnico == "V1011PTRED" && oPoliza.generales.productoComercial == "TRASCIENDE") {
			console.log("información de poliza")
			console.log(oPoliza.generales);
			fInicio = oPoliza.generales.fchInicioPoliza;
			fFin = oPoliza.generales.fchFinPlazoVida;
		}
	}

	fInicioLargo = fInicio != "" ? moment(fInicio, "DD/MM/YYYY").format("LL") : "";
	fFinLargo = fFin != "" ? moment(fFin, "DD/MM/YYYY").format("LL") : "";

	return {
		"inicio": fInicio,
		"fin": fFin,
		"inicioLargo": fInicioLargo,
		"finLargo": fFinLargo
	};
}



// WEBPACK FOOTER //
// ./src/home/logicaFechas.js